import { truncateString } from '../TaskPreferences/Messages';
import { getLanguageBaseOnTZ } from '../../utils/LanguageLocalStorage';
import i18n from '../../i18n';

export default {
  archiveIconTitle: 'بایگانی',
  subtasks: 'زیروظایف',
  printTaskIconTitle: 'چاپ وظیفه',
  videoCall: 'تماس تصویری',
  sendSMS: 'ارسال پیامک',
  restoreTaskIconTitle: 'بازگردانی',
  taskSettingsIconTitle: 'تنظیمات',
  editTask: 'ویرایش',
  close: 'بستن',
  removePermission: 'حذف دسترسی',
  active: 'فعال',
  activeFromParent: 'فعال از طریق یکی از پوشه ‌های دربرگیرنده',
  inactive: 'غیر فعال',
  duplicate: 'ایجاد مشابه',
  AddAttachments: 'افزودن ضمیمه',
  copied: 'کپی شد',
  onlyInPart: '(فقط بخش خود)',
  assignee: 'مجریان',
  android: 'اندروید',
  iOS: 'آیفون',
  draftTask: 'تغییر به پیشنویس',
  addAttachments: 'افزودن ضمیمه',
  deleted: 'حذف شده',
  in: 'در',
  taskWeight: 'وزن',
  activeFromHigherPermission: 'فعال از طریق دسترسی سطح بالاتر',
  enterSMS: 'لطفا پیام خود را وارد کنید',
  hint: 'لطفا پس از انتخاب نوع تلفن همراهتان، کد بالارا با تلفن همراه خود اسکن کنید و یا دکمه زیر را در تلفن همراه خود بزنید',

  deleteTask(taskName: string) {
    return i18n.t('deleteTask', { ns: 'taskManager', taskName });
  },
  confirmRestoreTask(taskTitle: string, subTasksTitle?: string) {
    const subTasksCustomTitle = subTasksTitle ? subTasksTitle : 'گام‌های';
    return `آیا از بازگردانی «${truncateString(
      taskTitle,
      50
    )}» و تمام ${subTasksCustomTitle} آن مطمئن هستید؟`;
  },
  subtaskFor(parentTaskName: string, taskName: string) {
    return `${taskName} برای «${parentTaskName}»`;
  },
  confirmArchiveATask(
    taskTitle: string,
    subtaskTitle: string | undefined,
    archived: boolean
  ) {
    return !archived
      ? i18n.t('archiveTask', {
          ns: 'taskManager',
          taskTitle:
            taskTitle || subtaskTitle || i18n.t('steps', { ns: 'taskManager' }),
        })
      : i18n.t('unarchiveTask', { ns: 'taskManager', taskTitle });
  },
  changePermissionTo(permissionTitleElement: string, lessThanActive: boolean) {
    const lang = getLanguageBaseOnTZ();
    return lang === 'fa'
      ? `تغییر دسترسی به ${permissionTitleElement}${
          lessThanActive ? ' و حذف دسترسی های بالاتر ' : ''
        }`
      : `Change permission to ${permissionTitleElement}${
          lessThanActive ? ' and remove higher permissions ' : ''
        }`;
  },
  taskIsLocked(taskName: string, allowUnlock: boolean) {
    const rest = allowUnlock
      ? '، جهت بازگشایی کلیک کنید'
      : ' و امکان ویرایش آن وجود ندارد.';
    return `این ${taskName} قفل است${rest}`;
  },
  unlockTask(taskName: string) {
    return `ایا از بازگشایی قفل این ${taskName} مطمئن هستید؟`;
  },
  sendMessageTo(s: string) {
    return i18n.t('sendMessageTo', { ns: 'taskManager', s });
  },
  confirmDeleteATask(taskTitle: string, subTasksTitle?: string) {
    const subTasksCustomTitle = subTasksTitle ? subTasksTitle : 'گام‌های';
    return `آیا از حذف «${truncateString(
      taskTitle,
      50
    )}» و تمام ${subTasksCustomTitle} آن مطمئن هستید؟`;
  },

  moveTask(taskName: string) {
    return i18n.t('moveTask', { ns: 'taskManager', taskName });
  },
};
